{
  "CONTACTS_FILTER": {
    "TITLE": "Filtrar contactos",
    "SUBTITLE": "Adicione filtros, abaixo, e clique em 'Submeter' para filtrar contactos.",
    "EDIT_CUSTOM_SEGMENT": "Editar segmento",
    "CUSTOM_VIEWS_SUBTITLE": "Adicione ou remova filtros e atualize o seu segmento.",
    "ADD_NEW_FILTER": "Adicionar filtro",
    "CLEAR_ALL_FILTERS": "Limpar todos os filtros",
    "FILTER_DELETE_ERROR": "Deve ter, pelo menos, um filtro para guardar",
    "SUBMIT_BUTTON_LABEL": "Submeter",
    "UPDATE_BUTTON_LABEL": "Atualizar segmento",
    "CANCEL_BUTTON_LABEL": "Cancelar",
    "CLEAR_BUTTON_LABEL": "Limpar filtros",
    "EMPTY_VALUE_ERROR": "Valor obrigatório",
    "SEGMENT_LABEL": "Nome do segmento",
    "SEGMENT_QUERY_LABEL": "Consulta de segmento",
    "TOOLTIP_LABEL": "Filtrar contactos",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "E",
      "OR": "OU"
    },
    "OPERATOR_LABELS": {
      "equal_to": "Igual a",
      "not_equal_to": "Não é igual a",
      "contains": "Contém",
      "does_not_contain": "Não contém",
      "is_present": "Está presente",
      "is_not_present": "Não está presente",
      "is_greater_than": "É maior do que",
      "is_lesser_than": "É menor do que",
      "days_before": "É x dias antes"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Valor obrigatório"
    },
    "ATTRIBUTES": {
      "NAME": "Nome",
      "EMAIL": "E-mail",
      "PHONE_NUMBER": "Número de telefone",
      "IDENTIFIER": "Identificador",
      "CITY": "Cidade",
      "COUNTRY": "País",
      "CUSTOM_ATTRIBUTE_LIST": "Lista",
      "CUSTOM_ATTRIBUTE_TEXT": "Texto",
      "CUSTOM_ATTRIBUTE_NUMBER": "Número",
      "CUSTOM_ATTRIBUTE_LINK": "Endereço",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Caixa de seleção",
      "CREATED_AT": "Criado em",
      "LAST_ACTIVITY": "Última atividade",
      "REFERER_LINK": "Link de referência",
      "BLOCKED": "Bloqueado",
      "LABELS": "Etiquetas"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Filtros padrão",
      "ADDITIONAL_FILTERS": "Filtros adicionais",
      "CUSTOM_ATTRIBUTES": "Atributos personalizados"
    }
  }
}
